import { render, staticRenderFns } from "./splash_image_configurator.vue?vue&type=template&id=608fad78&"
import script from "./splash_image_configurator.vue?vue&type=script&lang=js&"
export * from "./splash_image_configurator.vue?vue&type=script&lang=js&"
import style0 from "./splash_image_configurator.vue?vue&type=style&index=0&id=608fad78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports